/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProductBundleDetails {
    getFixupPrototypeFunction() { return ProductBundleDetails.fixupPrototype; }

    static newInstance(model: Partial<ProductBundleDetails>): ProductBundleDetails {
        let obj = Object.assign(new ProductBundleDetails(), model);
        ProductBundleDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProductBundleDetails>): ProductBundleDetails {
        if (!model) return null;
        return ProductBundleDetails.newInstance(<ProductBundleDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProductBundleDetails) {
        if (!obj) return;

        models.ProductBundleDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProductBundleDetails): boolean {
        Object.setPrototypeOf(obj, ProductBundleDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the product bundle
     */
    name: string;

    /**
     * Description of the product bundle
     */
    description: string;

    /**
     * Products included in the bundle
     */
    products: Array<string>;

}
